module.exports = __webpack_public_path__ + "media/images/brand/400/MARQUESBRANDINGCO LOGO SOCIALMEDIA_DESTAQUES-0802e813e40b8126497f07b4fb80e06e.png";